// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const PortsIcon = createSvgIcon(
  <svg width={24} height={24} fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M20.7 14.79h-.59v-2.11a1.3 1.3 0 0 0-1.29-1.3h-6.17V9.2h.84a1.3 1.3 0 0 0 1.3-1.3v-3a1.3 1.3 0 0 0-1.3-1.3h-3a1.3 1.3 0 0 0-1.3 1.3v3a1.3 1.3 0 0 0 1.3 1.3h.84v2.17H5.18a1.3 1.3 0 0 0-1.29 1.3v2.1H3.3a1.3 1.3 0 0 0-1.3 1.3v3a1.3 1.3 0 0 0 1.3 1.3h3a1.3 1.3 0 0 0 1.3-1.3v-3a1.3 1.3 0 0 0-1.3-1.3H5.19v-2.1h6.17v2.1h-.84a1.3 1.3 0 0 0-1.3 1.3v3a1.3 1.3 0 0 0 1.3 1.3h3a1.3 1.3 0 0 0 1.3-1.3v-3a1.3 1.3 0 0 0-1.3-1.3h-.84v-2.1h6.16v2.1h-1.12a1.3 1.3 0 0 0-1.3 1.3v3a1.3 1.3 0 0 0 1.3 1.3h3a1.3 1.3 0 0 0 1.3-1.3v-3a1.3 1.3 0 0 0-1.32-1.3M10.51 4.93h3v3h-3zM6.28 19.07h-3v-3h3zm7.21 0h-3v-3h3zm4.23 0v-3h3v3z"
    />
  </svg>,
  "Ports",
);
export default PortsIcon;
